/** 解析为 YYYY-MM-DD；无法解析则 null */
export function parseYmd(value: string | null | undefined): string | null {
  if (!value) return null;
  const matched = /^(\d{4}-\d{2}-\d{2})/.exec(String(value).trim());
  return matched ? matched[1] : null;
}

/** 计划日、实际日齐全时：实际日 ≤ 计划日为「是」，否则「否」 */
export function ontimeFromPlanAndActual(
  plan: string | null | undefined,
  actual: string | null | undefined,
): '是' | '否' | null {
  const planYmd = parseYmd(plan);
  const actualYmd = parseYmd(actual);
  if (!planYmd || !actualYmd) return null;
  return actualYmd <= planYmd ? '是' : '否';
}

export function formatOntimeDisplay(
  plan: string | null | undefined,
  actual: string | null | undefined,
): string {
  const flag = ontimeFromPlanAndActual(plan, actual);
  if (flag) return flag;
  return '—';
}

export interface OntimeDateFields {
  replyPlan?: string | null;
  replyActual?: string | null;
  replyOntime?: string | null;
  defectPlan?: string | null;
  defectActual?: string | null;
  defectOntime?: string | null;
  closePlan?: string | null;
  closeActual?: string | null;
  closeOntime?: string | null;
}

/** 写入三套是否按时（可算则覆盖，否则保留原值或 null） */
export function applyComputedOntime<T extends OntimeDateFields>(row: T): T {
  const reply = ontimeFromPlanAndActual(row.replyPlan, row.replyActual);
  const defect = ontimeFromPlanAndActual(row.defectPlan, row.defectActual);
  const close = ontimeFromPlanAndActual(row.closePlan, row.closeActual);
  return {
    ...row,
    replyOntime: reply ?? row.replyOntime ?? null,
    defectOntime: defect ?? row.defectOntime ?? null,
    closeOntime: close ?? row.closeOntime ?? null,
  };
}

/** 保存口径：选手动值；未选时按计划日与实际日推算 */
export function resolveOntimeForSave(
  manual: string | null | undefined,
  plan: string | null | undefined,
  actual: string | null | undefined,
): string | null {
  const trimmed = (manual || '').trim();
  if (trimmed === '是' || trimmed === '否') return trimmed;
  return ontimeFromPlanAndActual(plan, actual);
}

/** KPI：有日期则按日期算，否则回退表内「是否按时」 */
export function effectiveOntimeFlag(
  plan: string | null | undefined,
  actual: string | null | undefined,
  stored: string | null | undefined,
): boolean {
  const computed = ontimeFromPlanAndActual(plan, actual);
  if (computed) return computed === '是';
  return (stored || '').trim() === '是';
}
